/**
 * plugins/vuetify.js
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { pl, en, es, nl } from 'vuetify/locale'

// Composables
import { createVuetify } from 'vuetify'
import { pit } from './icons'
// import { VTimePicker } from 'vuetify/labs/VTimePicker'
import { VDateInput } from 'vuetify/labs/VDateInput'
// import { VTreeview } from 'vuetify/labs/VTreeview'
// import { VCalendar } from 'vuetify/labs/VCalendar'


function determine_theme() {
  const web_dark = window.matchMedia('(prefers-color-scheme: dark)').matches
  let theme = localStorage.getItem("theme");
  if (!theme || theme == "auto") theme = web_dark ? "dark" : "light"
  return theme
}



// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  // Adds our own set next to MDI. `createIcons` builds its defaults first and
  // merges this on top, and it installs the `mdi` set whenever `defaultSet` is
  // "mdi" — which is its own default — so MDI and the ~54 aliases Vuetify uses
  // internally (chevrons, checkboxes, pagination) are untouched by this.
  icons: {
    sets: { pit },
  },
  defaults: {
    // A card on the page has a thin border and no shadow; what floats keeps
    // its shadow (docs/flat-cards-proposal.md). Both props are needed: with
    // `border` alone the elevated variant's shadow still wins.
    VCard: { variant: 'flat', border: true },
    // Buttons keep their fill and lose the shadow. v-card-actions and
    // v-toolbar still turn their buttons into text ones: their defaults are
    // closer than this one.
    VBtn: { variant: 'flat' },
    // One look for switches and checkboxes (docs/toggles-proposal.md): accent
    // when on, compact, and no empty message row unless there is a message.
    // VCheckboxBtn also reaches the row selection Vuetify draws in tables.
    VSwitch: { color: 'accent', density: 'compact', hideDetails: 'auto', inset: true },
    VCheckbox: { color: 'accent', density: 'compact', hideDetails: 'auto' },
    VCheckboxBtn: { color: 'accent', density: 'compact' },
    VRadioGroup: { color: 'accent', density: 'compact', hideDetails: 'auto' },
    VTextField: { autocomplete: 'off' },
    VTextarea: { autocomplete: 'off' },
    VAutocomplete: { autocomplete: 'off' },
    VCombobox: { autocomplete: 'off' },
  },
  components: {
    // VTimePicker, // ADDED TO VUETIFTY CORE
    // VTreeview, // ADDED TO VUETIFTY CORE
    VDateInput,
    // VCalendar, // ADDED TO VUETIFTY CORE
  },
  theme: {
    defaultTheme: determine_theme(),
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#1976D2',
          secondary: '#242021',
          accent: '#ea590c',
          error: '#c90202', // default was '#FF5252'
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#ea590c',
          worange: "#ea590c",  // accent, warning produuz.it
          wblack: "#242021",  // secondary produuz.it
        },
      },
      dark: {
        dark: true,
        colors: {
          primary: '#1976D2',
          secondary: "#707070",
          accent: '#ea590c',
          error: '#c90202', // default was '#FF5252'
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#ea590c',
          worange: "#ea590c",  // accent, warning produuz.it
          wblack: "#242021",  // secondary produuz.it
          // The inset switch thumb; Vuetify's dark default is a lilac (#ccbfd6).
          "surface-bright": "#E6E6E6",
        }
      }
    },
  },
  locale: {
    locale: 'en',
    messages: { en, nl, es, pl },
  },
})
